import { Route as rootRoute } from './routes/__root';
import { Route as IndexRoute } from './routes/index';
import { Route as InboxesRoute } from './routes/inboxes';
import { Route as MailRoute } from './routes/mail';
import { Route as DomainsRoute } from './routes/domains';
import { Route as ApiKeysRoute } from './routes/api-keys';
import { Route as WebhooksRoute } from './routes/webhooks';
import { Route as UsageRoute } from './routes/usage';
import { Route as SettingsRoute } from './routes/settings';
import {
  AdminActivityRoute,
  AdminIndexRoute,
  AdminLeadDetailRoute,
  AdminLeadsRoute,
  AdminOrgDetailRoute,
  AdminOrgsRoute,
  AdminRoute,
  AdminSystemRoute,
} from './routes/admin';

export const routeTree = rootRoute.addChildren([
  IndexRoute,
  InboxesRoute,
  MailRoute,
  DomainsRoute,
  ApiKeysRoute,
  WebhooksRoute,
  UsageRoute,
  SettingsRoute,
  AdminRoute.addChildren([
    AdminIndexRoute,
    AdminLeadsRoute,
    AdminLeadDetailRoute,
    AdminOrgsRoute,
    AdminOrgDetailRoute,
    AdminActivityRoute,
    AdminSystemRoute,
  ]),
]);
